import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";

import { getPlayingLevels } from "../services/playingLevels";

export const usePlayingLevels = () => {
  const { i18n } = useTranslation();

  const {
    data,
    isLoading: isPlayingLevelsLoading,
    isError: isPlayingLevelsError,
  } = useQuery({
    queryKey: ["PlayingLevels", i18n.language],
    queryFn: getPlayingLevels,
  });

  const playingLevels = data?.items || [];

  return {
    playingLevels,
    isPlayingLevelsLoading,
    isPlayingLevelsError,
  };
};
